
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AddAdministrativeCostsComments, GetAllAdministrativeCostsCommentsByStagesGuid } from "../../Redux/Reducers/ReportStage/AdministrativeCostsComments"
import InputAHSF from "../../Components/InputAHSF"
import ButtonAHSF from "../../Components/ButtonAHSF"
import './style.css'
const CommentPopup = (props) => {
    const dispatch = useDispatch()
    const userInfo = useSelector((state) => state.UserInfo.UserInfo)
    const allComment = useSelector((state) => state.AdministrativeCostsComments.AdministrativeCostsCommentsLists)
    const [comment, setComment] = useState(null)
    console.log(allComment, "sdksdlskdlkwdw");

    useEffect(() => {
        dispatch(GetAllAdministrativeCostsCommentsByStagesGuid({
            pR_AdministrativeCostsId: props.PR_EstimatedBudgetForAdministrativeCostsId,
            pR_ReportsStagesGuid: props.stageGuid,
            employeeType: userInfo?.userToken?.userType
        }))
    }, [])

    const AddComment = () => {
        dispatch(AddAdministrativeCostsComments({
            pR_EstimatedBudgetForAdministrativeCostsId: props.PR_EstimatedBudgetForAdministrativeCostsId,
            pR_ReportsStagesGuid: props.stageGuid,
            comment: comment,
            uS_UserGuid: userInfo?.userToken?.userGuid,
            canEdit: true
        }))
    }
    return (
        <>
            {
                allComment ? <div className="containerCommentPopup">
                    <div className="">

                        <div>
                            {
                                allComment && allComment.map((ele, ind) => {
                                    console.log(ind, "sdsssss");

                                    return (
                                        <div className="containerComment">
                                            <div className="containerCommentAndDate">
                                                <div>
                                                    <p>
                                                        {
                                                            ele.
                                                                comment
                                                        }
                                                    </p>
                                                </div>
                                                <div className="NameAndDate">
                                                    <div className="NameUser">
                                                        {
                                                            ele.uS_User.firstName + " " + ele.uS_User.lastName

                                                        }
                                                    </div>
                                                    <div className="DateCommint">
                                                        {
                                                            ele.dateCreate


                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="containerAction">
                                                <div>

                                                    {ele.showSubmitter == false ? (
                                                        <div>
                                                            <i class="bi bi-eye-slash"></i>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <i class="bi bi-eye"></i>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className=""> 
                                                <i class="bi bi-trash3-fill"></i>
                                                </div>
                                            </div>
                                        </div>)
                                })
                            }
                        </div>


                        <div >
                            <InputAHSF
                                fieldsName="CommentInput"
                                show={true}
                                disabled={props.disabledData ? true : false}
                                defaultValue={
                                    ""
                                }
                                onChange={(e) => {
                                    setComment(e.target.value);
                                }}
                                showValidationMessage={false}
                                validationMessage={"حقل اجباري"}
                            />
                        </div>
                    </div>
                    <div className="containerButton">
                        <ButtonAHSF
                            onClick={
                                AddComment
                            }
                            text={"حفظ"}
                            show={true}
                        />
                    </div>
                </div> : <></>
            }
        </>
    )
}

export default CommentPopup